export enum DeliveryTypes {
    NonMainlandDelivery = 'nonMainlandCourier'
}

export function stringToDeliveryTypes(value: string | null): DeliveryTypes | null {
    switch (value) {
        case DeliveryTypes.NonMainlandDelivery:
            return DeliveryTypes.NonMainlandDelivery;
        default:
            return null;
    }
}